import { render } from "./SaleSimple.vue?vue&type=template&id=085c4bbf&scoped=true"
import script from "./SaleSimple.vue?vue&type=script&lang=js"
export * from "./SaleSimple.vue?vue&type=script&lang=js"

import "./SaleSimple.vue?vue&type=style&index=0&id=085c4bbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085c4bbf"]])

export default __exports__